import { actionTypes } from 'redux-query';

/**
 * Если передан meta.successCallback, он будет вызван.
 *
 * @return {void}
 */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export default () => (next) => (action) => {
  if (action.type === actionTypes.REQUEST_SUCCESS) {
    const { successCallback } = action.meta;

    const backendVersion = action.responseHeaders['backend-version'];

    if (backendVersion) {
      localStorage.setItem('version', backendVersion);
    }

    if (successCallback) {
      successCallback(action.responseBody);
    }
  }

  return next(action);
};
